import { isKycTypeConditionSatisfied } from "../components/structures/helpers"

const getCompanyStructureFields = ({
    fields: companyFields,
    supportedRegions,
    country,
    kycType,
    t,
}) => {
    let fields = [...companyFields]
    if (supportedRegions) {
        if (
            !!supportedRegions[country] &&
            !fields.find((f) => f.id === "region")
        ) {
            const mappedFields = fields.map((f) =>
                f.id === "registeredAddressCountry" ? "reg" : "No"
            )
            const spliceIndex = mappedFields.indexOf("reg") + 1

            fields.splice(spliceIndex, 0, {
                id: "region",
                type: "SELECT",
                customOptions: supportedRegions[country].map((u) => ({
                    value: u,
                    label: u.toUpperCase(),
                })),
                editable: true,
            })
        } else if (
            !supportedRegions[country] &&
            fields.find((f) => f.id === "region")
        ) {
            fields = fields.filter((f) => f.id !== "region")
        }
    }

    return fields
        .filter(field => isKycTypeConditionSatisfied({ field, kycType }))
        .map((field) => ({ ...field, customLabel: field.customLabel || t(field.label)}))
}

const getPersonStructureFields = ({ fields, kycType, t }) => {
    return fields
        .filter(field => isKycTypeConditionSatisfied({ field, kycType }))
        .map((field) => ({ ...field, customLabel: field.customLabel || t(field.label)}))
}

export { getCompanyStructureFields, getPersonStructureFields }
